import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Analytics from "@/components/Analytics";
import HomePage from "@/pages/HomePage";
import QuotePage from "@/pages/QuotePage";
import BookingPage from "@/pages/BookingPage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import ReviewsPage from "@/pages/ReviewsPage";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Main site layout with navbar/footer
const MainLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Routes>
          {/* Admin routes - no navbar/footer */}
          <Route path="/admin/analytics" element={<AnalyticsDashboard />} />
          
          {/* Main site routes with navbar/footer */}
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/quote" element={<MainLayout><QuotePage /></MainLayout>} />
          <Route path="/booking" element={<MainLayout><BookingPage /></MainLayout>} />
          <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
          <Route path="/services" element={<MainLayout><ServicesPage /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
          <Route path="/reviews" element={<MainLayout><ReviewsPage /></MainLayout>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
